export class Transaksi {
    nama_barang: string;
    harga_satuan: number;
    jumlah_barang: number;
    harga_total: number;
    diskon: number;
    dpp: number;
    ppn: number;
    tarif_ppnbm: number;
    ppnbm: number;
}



// WEBPACK FOOTER //
// ./src/app/transaksi.ts